import { buildWebLoginUrl } from '@/lib/urls';

let redirecting = false;

/** Redirect to the web app login, preserving the current URL for return. */
export function redirectToWebLogin(): void {
  if (redirecting || typeof window === 'undefined') {
    return;
  }

  redirecting = true;
  const returnUrl = window.location.href;
  window.location.assign(buildWebLoginUrl(returnUrl));
}
